import { AxiosResponse } from 'axios';
import { SET_EMPLOYEE_SALARY_PROMOTIONS, SET_EMPLOYEE_SALARY_PROMOTION, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_EMPLOYEE_SALARY_PROMOTION_ISLOADING,
  DELETE_EMPLOYEE_SALARY_PROMOTION,
  EDIT_EMPLOYEE_SALARY_PROMOTION,
  GET_EMPLOYEE_SALARY_PROMOTIONS,
  GET_EMPLOYEE_SALARY_PROMOTION,
  REGISTER_EMPLOYEE_SALARY_PROMOTION,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import EmployeeSalaryPromotion from '@/services/employee_salary_promotion';
import { Module } from 'vuex';
import { EditEmployeeSalaryPromotion, RegisterEmployeeSalaryPromotion, GetEmployeeSalaryPromotion, DeleteEmployeeSalaryPromotion } from '@/dtos/employee_salary_promotion.dto';

const employeeSalaryPromotion: Module<any, {}> = {
  state: {
    employeeSalaryPromotion: {
      data: null,
      isLoading: false,
    },
    employeeSalaryPromotions: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    employeeSalaryPromotion: (state: { employeeSalaryPromotion: any }) => state.employeeSalaryPromotion,
    employeeSalaryPromotions: (state: { employeeSalaryPromotions: any }) => state.employeeSalaryPromotions,
  },
  mutations: {
    [SET_EMPLOYEE_SALARY_PROMOTION]: (
      state: { employeeSalaryPromotion: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeSalaryPromotion.data = payload.data) : null,
        (state.employeeSalaryPromotion.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEE_SALARY_PROMOTIONS]: (
      state: { employeeSalaryPromotions: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeSalaryPromotions.data = payload.data) : null,
        (state.employeeSalaryPromotions.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_EMPLOYEE_SALARY_PROMOTION]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_SALARY_PROMOTION, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeSalaryPromotion.registerEmployeeSalaryPromotion(
        payload as RegisterEmployeeSalaryPromotion
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_SALARY_PROMOTION, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_SALARY_PROMOTION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_SALARY_PROMOTION, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_SALARY_PROMOTIONS]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_SALARY_PROMOTIONS, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeSalaryPromotion.getEmployeeSalaryPromotions(
        payload as GetEmployeeSalaryPromotion
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_SALARY_PROMOTIONS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_SALARY_PROMOTIONS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_SALARY_PROMOTIONS, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_SALARY_PROMOTION]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_SALARY_PROMOTION, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeSalaryPromotion.getEmployeeSalaryPromotions(
        payload as GetEmployeeSalaryPromotion
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_SALARY_PROMOTION, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_SALARY_PROMOTION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_SALARY_PROMOTION, { isLoading: false });
        return false;
      }
    },
    [EDIT_EMPLOYEE_SALARY_PROMOTION]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_SALARY_PROMOTION, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeSalaryPromotion.editEmployeeSalaryPromotion(
        payload as EditEmployeeSalaryPromotion
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_SALARY_PROMOTION, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_SALARY_PROMOTION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_SALARY_PROMOTION, { isLoading: false });
        return false;
      }
    },
    [DELETE_EMPLOYEE_SALARY_PROMOTION]: async ({ commit }: any, payload: string) => {
      commit(SET_EMPLOYEE_SALARY_PROMOTION, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeSalaryPromotion.deleteEmployeeSalaryPromotion(payload as unknown as DeleteEmployeeSalaryPromotion);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_SALARY_PROMOTION, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_SALARY_PROMOTION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_SALARY_PROMOTION, { isLoading: false });
        return false;
      }
    },
    [CLEAR_EMPLOYEE_SALARY_PROMOTION_ISLOADING]: ({ commit }) => {
      commit(SET_EMPLOYEE_SALARY_PROMOTION, { isLoading: false });
      commit(SET_EMPLOYEE_SALARY_PROMOTIONS, { isLoading: false });
    },
  },
};

export default employeeSalaryPromotion;
